import { useLocation } from 'react-router-dom'
import { getBackgroundFromPath } from '../../utils/backgroundManager'

interface PageHeroProps {
  title: string | React.ReactNode
  subtitle?: string
  description?: string
  children?: React.ReactNode
  customBackground?: string
  className?: string
}

const PageHero = ({ 
  title, 
  subtitle, 
  description, 
  children, 
  customBackground,
  className = "section-padding"
}: PageHeroProps) => {
  const location = useLocation()
  const backgroundImage = customBackground || getBackgroundFromPath(location.pathname)

  return (
    <section className={`${className} relative text-white overflow-hidden`}>
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className="absolute inset-0 bg-black bg-opacity-50" />
      
      <div className="container-custom relative z-10">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 leading-tight">
            {title}
          </h1>
          
          {subtitle && (
            <h2 className="text-xl sm:text-2xl md:text-3xl font-semibold mb-3 sm:mb-4 text-accent">
              {subtitle}
            </h2>
          )}
          
          {description && (
            <p className="text-lg sm:text-xl md:text-2xl text-gray-200 mb-6 sm:mb-8 max-w-3xl mx-auto">
              {description}
            </p>
          )}
          
          {children && (
            <div className="mt-6 sm:mt-8">
              {children}
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default PageHero